// Non usare i trattini perchè causano errori
export const RECEIPTS_DESCRIBE: string = 'receipts';

export const TAGLI_CONTANTI = [
  { descrizioneTaglio: 'Banconote da 500', importoTaglio: 500 },
  { descrizioneTaglio: 'Banconote da 200', importoTaglio: 200 },
  { descrizioneTaglio: 'Banconote da 100', importoTaglio: 100 },
  { descrizioneTaglio: 'Banconote da 50', importoTaglio: 50 },
  { descrizioneTaglio: 'Banconote da 20', importoTaglio: 20 },
  { descrizioneTaglio: 'Banconote da 10', importoTaglio: 10 },
  { descrizioneTaglio: 'Banconote da 5', importoTaglio: 5 },
  { descrizioneTaglio: 'Monete', importoTaglio: 0 },
] as const;
